import {
    GET_OPERATOR_TRIP_DETAILS_START,
    GET_OPERATOR_TRIP_DETAILS_SUCCESS,
    GET_OPERATOR_TRIP_DETAILS_ERROR,
    GET_OPERATOR_TRIP_INQUIRY_LIST_START,
    GET_OPERATOR_TRIP_INQUIRY_LIST_SUCCESS,
    GET_OPERATOR_TRIP_INQUIRY_LIST_ERROR,
    GET_OPERATOR_RIDERS_WITH_BOOKING_LIST_START,
    GET_OPERATOR_RIDERS_WITH_BOOKING_LIST_SUCCESS,
    GET_OPERATOR_RIDERS_WITH_BOOKING_LIST_ERROR,
} from "../Constants/OperatorTripDetailsConstant";

const initialState = {
    loading: false,
    operatorTripDetailsData:[],
    operatorTripInquiryList:[],
    operatorTripRidersWithBokkingList:[],
  };

  export default function OperatorTripDetailsReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case GET_OPERATOR_TRIP_DETAILS_START:
            return {
                ...state,
                loading: true,
            };
        case GET_OPERATOR_TRIP_DETAILS_SUCCESS:
            return {
                ...state,
                operatorTripDetailsData: action.payload,
                loading: false,
            };
        case GET_OPERATOR_TRIP_DETAILS_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };

            case GET_OPERATOR_TRIP_INQUIRY_LIST_START:
                return {
                    ...state,
                    operatorTripInquiryList:[],
                    loading: true,
                };
            case GET_OPERATOR_TRIP_INQUIRY_LIST_SUCCESS:
                return {
                    ...state,
                    operatorTripInquiryList: action.payload,
                    loading: false,
                };
            case GET_OPERATOR_TRIP_INQUIRY_LIST_ERROR:
                return {
                    ...state,
                    loading: false,
                    message: action.error.message,
                };


            case GET_OPERATOR_RIDERS_WITH_BOOKING_LIST_START:
                return {
                    ...state,
                    loading: true,
                };
            case GET_OPERATOR_RIDERS_WITH_BOOKING_LIST_SUCCESS:
                return {
                    ...state,
                    operatorTripRidersWithBokkingList: action.payload,
                    loading: false,
                };
            case GET_OPERATOR_RIDERS_WITH_BOOKING_LIST_ERROR:
                return {
                    ...state,
                    loading: false,
                    message: action.error.message,
                };
        default:
            return state;
    }
}